import { ColunaConfig } from "components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica";
import { normalizeCurrency } from "core/utils/normalizeCurrency";
import { formatPercent } from "./IndicadorUtil";

export interface IndicadorFaturamentoMensal {
  categories: string[];
  series: IndicadorFaturamentoMensalSerie[];
  tabelaClientes: IndicadorFaturamentoMensalTabelaCliente[];
  tabelaUnidades: IndicadorFaturamentoMensalTabelaUnidade[];
  ano: number;
  mes: number;
}

export interface IndicadorFaturamentoMensalSerie {
  name: string;
  data: number[];
}

export interface IndicadorFaturamentoMensalTabelaCliente {
  cliente: string;
  faturamento: number;
  percentualSobreFaturamento: number;
  quantidadeViagens: number;
  ticketMedio: number;
  margem: string;
  restituicao: number;
  impostoFederal: number;
  custoAdm: number;
}

export interface IndicadorFaturamentoMensalTabelaUnidade {
  unidade: string;
  faturamentoAnoAnterior: number;
  faturamentoAnoSelecionado: number;
  crescimentoAA: number;
  margem: string;
  restituicao: number;
  impostoFederal: number;
  custoAdm: number;
}

export const getColunasTabelaClientes: ColunaConfig<IndicadorFaturamentoMensalTabelaCliente>[] = [
  { field: "cliente", nomeColuna: "Cliente" },
  { field: "faturamento", nomeColuna: "Faturamento" },
  { field: "percentualSobreFaturamento", nomeColuna: "% Sobre faturamento" },
  { field: "quantidadeViagens", nomeColuna: "Qtd. viagens" },
  { field: "ticketMedio", nomeColuna: "Ticket Médio" },
  { field: "restituicao", nomeColuna: "Restituição" },
  { field: "margem", nomeColuna: "Margem" },
  { field: "impostoFederal", nomeColuna: "Imposto Federal" },
  { field: "custoAdm", nomeColuna: "Custo Adm" },
];

export const getColunasTabelaUnidades = (tabelaAnteriorLabel: string, tabelaAtualLabel: string): ColunaConfig<IndicadorFaturamentoMensalTabelaUnidade>[] => [
  { field: "unidade", nomeColuna: "Unidade" },
  { field: "faturamentoAnoAnterior", nomeColuna: tabelaAnteriorLabel },
  { field: "faturamentoAnoSelecionado", nomeColuna: tabelaAtualLabel },
  { field: "crescimentoAA", nomeColuna: "Crescimento A/A" },
  { field: "margem", nomeColuna: "Margem" },
  { field: "restituicao", nomeColuna: "Restituição" },
  { field: "impostoFederal", nomeColuna: "Imposto Federal" },
  { field: "custoAdm", nomeColuna: "Custo Adm" },
];

export const getColunasTabelaSeries = (categories: string[]): ColunaConfig<any>[] => {
  const colunas: ColunaConfig<any>[] = [
    { field: "name", nomeColuna: "Série", minWidth: 130 },
  ];

  categories.forEach((category, index) => {
    colunas.push({
      field: `data[${index}]`,
      nomeColuna: category,
      minWidth: 120,
      render: (row) =>
        row.name.includes("%")
          ? formatPercent(row.data[index])
          : normalizeCurrency(row.data[index]),
    });
  });

  return colunas;
};